import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const ActiveSupplierQuoteFragmentDoc = gql`
  fragment ActiveSupplierQuote on Price {
    tradeRelationship {
      id
      status
    }
    supplier {
      id
    }
  }
` as unknown as DocumentNode<Types.ActiveSupplierQuoteFragment, unknown>
